export default __webpack_public_path__ + "static/media/MB_Dash.143d850d.png";